export default __webpack_public_path__ + "static/media/Social strategy-cuate 1.27c265dd.svg";